import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';

export default function setTopBar() {
  const topBar = document.querySelector("[data-top-bar]");
  if (!topBar) return

  const topBarSwiper = new Swiper(topBar.querySelector('.swiper'), {
    modules: [Autoplay, EffectFade],
    slidesPerView: 1,
    spaceBetween: 0,
    watchOverflow: true,
    loop: true,
    speed: 2500,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
  });

  // Autoplay
  topBarSwiper.autoplay.stop();
  const eventType = window.mobile ? 'scroll' : 'mousemove';
  window.addEventListener(eventType, topBarSwiper.autoplay.start, { once: true });
}